











































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, PropSync } from 'vue-property-decorator';
import FormNavigationButtons from '@/components/tickets/tickets-form/common/FormNavigationButtons.vue';
import * as rules from '@/modules/shared/shared/domain/rules';
import { Typing } from '@/modules/tickets/shared/domain/typing';
import { ManagementManagedServicesData } from '@/modules/tickets/requirement/management-managed-services/domain/management-managed-services-data';
import PhoneField from '@/modules/shared/shared/components/PhoneField.vue';

@Component({
    name: 'management-managed-services-general-information',
    components: { PhoneField, FormNavigationButtons },
})
export default class ManagementManagedServicesGeneralInformation extends Vue {
    $refs!: {
        form: any;
    };

    private isFormValid: boolean = true;

    private rules: any = rules;

    validateStep() {
        if (this.$refs.form.validate()) {
            this.$emit('nextStep');
        }
    }

    @PropSync('valuesOfForm', { required: true })
    formValues!: {
        generalInformation: ManagementManagedServicesData;
        categoriesTypings: Typing[];
    };

    get requireDescriptionField() {
        let r = true;
        if (this.formValues.generalInformation.subject) {
            if (this.formValues.generalInformation.subject.name.toLowerCase().includes('otro')) {
                r = this.formValues.generalInformation.description
                    ? this.formValues.generalInformation.description.length > 0
                    : false;
            }
        }
        return r || 'Se requiere detallar el asunto del ticket';
    }
}
